import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { useLazyGetBranchByCodeQuery } from '@/features/local-configuration/api/local-configuration-api';
import {
  selectBranchCode,
  selectIsAuthenticated,
  setBranchDetail,
  setInitialized,
} from '@/features/auth/store/auth-slice';

/**
 * Bootstraps auth on app load.
 * Re-fetches branch detail in the background when a persisted session exists.
 */
export function useAuthInit() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const branchCode = useAppSelector(selectBranchCode);
  const [getBranch] = useLazyGetBranchByCodeQuery();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) {
      return;
    }
    hasInitialized.current = true;

    const init = async () => {
      if (isAuthenticated && branchCode) {
        try {
          const branch = await getBranch(branchCode).unwrap();
          dispatch(setBranchDetail(branch));
        } catch {
          // Branch detail is optional — keep the session even if this fetch fails
        }
      }
      dispatch(setInitialized(true));
    };

    void init();
  }, [branchCode, dispatch, getBranch, isAuthenticated]);
}
